import { stringify } from "query-string"

import { dhFoods } from "./api"

const endpoint = "/subscription-gift"

export const getSubscriptionGifts = async (queries) => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response =
    await dhFoods.get(`${endpoint}?${query}`)

  return response.data
}

export const createSubscriptionGift = async (data) => {
  const response =
    await dhFoods.post(`${endpoint}`, data)

  return response.data
}

export const updateSubscriptionGift = async (subscriptionGiftId, data) => {
  const response =
    await dhFoods.patch(`${endpoint}/${subscriptionGiftId}`, data)

  return response.data
}

export const deleteSubscriptionGift = async (subscriptionGiftId) => {
  const response =
    await dhFoods.delete(`${endpoint}/${subscriptionGiftId}`)

  return response.data
}